module.exports = __webpack_public_path__ + "img/input.fd627960.svg";